import React from 'react'
import { Col, Row, Container } from "react-bootstrap";
import BreadcrumbLayout from "../../component/Breadcrumb";
import HeadPara2 from "../../component/HeadPara2";
import { useTranslation } from "react-i18next";
function TermsAndCondition() {
  const { t } = useTranslation();
  const TermsAndConditionData = t("TermsAndCondition", { returnObjects: true });
  return (
    <>
      <BreadcrumbLayout title="Terms And Condition" />
      <Container fluid >
        <Row>
          <Col md={12} className="content order-md-last order-first">
            <Row>
              <Col xs={12} className="heading">
                <h3>{TermsAndConditionData.title}</h3>
              </Col>
              <Col xs={12} className="mb-1 mt-1">
                {TermsAndConditionData.data.map((items,i) => (
                  <HeadPara2 key={i} data={items} />
                ))}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default TermsAndCondition
